__turbopack_context__.v({
  "arrow": "Tooltip-module__X9TIHa__arrow",
  "bottom": "Tooltip-module__X9TIHa__bottom",
  "left": "Tooltip-module__X9TIHa__left",
  "right": "Tooltip-module__X9TIHa__right",
  "tooltip": "Tooltip-module__X9TIHa__tooltip",
  "tooltipContainer": "Tooltip-module__X9TIHa__tooltipContainer",
  "top": "Tooltip-module__X9TIHa__top",
});
